import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import { isFormValid } from '@/services/store-validation-checkers'
import { CountryInterface } from '@/services/countries'

Vue.use(Vuex)

export enum StoreMutations {
    SET_TEST_VERSION = 'SET_TEST_VERSION',
    UPDATE_STORE = 'UPDATE_STORE',
    ADD_LEAD_INFO = 'ADD_LEAD_INFO',
}

export enum StoreGetters {
    TEST_VERSION = 'TEST_VERSION',
    FORM = 'FORM',
    IS_COMPANY_FORM_VALID = 'IS_COMPANY_FORM_VALID',
    IS_PLATFORM_FORM_VALID = 'IS_PLATFORM_FORM_VALID',
    IS_ADMINISTRATOR_FORM_VALID = 'IS_ADMINISTRATOR_FORM_VALID',
    IS_FORM_VALID = 'IS_FORM_VALID',
    LEAD = 'LEAD',
}

export interface FormInterface {
    platformUrl?: string;
    platformName?: string;
    companyMail?: string;
    firstName?: string;
    lastName?: string;
    jobTitle?: string;
    industry?: string;
    industryOther?: string;
    navigationColor?: string;
    navigationTextColor?: string;
    callToActionColor?: string;
    activeAreas?: number[];
    password?: string;
    companyName?: string;
    country?: CountryInterface | '';
    logoUrl?: string;
    coverImageUrl?: string;
    avatarUrl?: string | null;
    logoName?: string;
    personalMail?: string;
    coverImageName?: string;
    avatarName?: string;
    recaptchaResponse?: string;
    urlParams?: object;
    region: string;
    utm_term: string;
    utm_content: string;
    utm_campaign: string;
    utm_medium: string;
    utm_source: string;
}

export interface LeadInterface {
    contactId: string;
    companyId: string;
}

export interface StateInterface {
    form: FormInterface;
    lead: LeadInterface;
}

const state: StateInterface = {
    form: {
        companyName: '',
        industry: '',
        country: '',
        platformName: '',
        platformUrl: '',
        navigationColor: '#0030C0',
        navigationTextColor: '#FFFFFF',
        callToActionColor: '#00AAED',
        logoUrl:
            'https://eloomismartsetupprod.blob.core.windows.net/industry-images/eloomi-logo.png',
        coverImageUrl:
            'https://eloomismartsetupprod.blob.core.windows.net/industry-images/hero.jpg',
        firstName: '',
        lastName: '',
        jobTitle: '',
        companyMail: '',
        personalMail: '',
        password: '',
        avatarUrl: null,
        logoName: '',
        coverImageName: '',
        avatarName: '',
        activeAreas: [],
        utm_term: '',
        utm_content: '',
        utm_campaign: '',
        utm_medium: '',
        utm_source: '',
        region: 'EU'
    },
    lead: {
        companyId: '',
        contactId: '',
    },
}

const store: Store<StateInterface> = new Vuex.Store({
    state,
    getters: {
        [StoreGetters.FORM]: state => state.form,
        [StoreGetters.LEAD]: state => state.lead,
        [StoreGetters.IS_FORM_VALID]: state => {
            return isFormValid(state.form)
        },
    },
    mutations: {
        [StoreMutations.UPDATE_STORE]: (state, data) => {
            state.form = { ...state.form, ...data }
        },
        [StoreMutations.ADD_LEAD_INFO]: (state, data: LeadInterface) => {
            state.lead = { ...state.lead, ...data }
        },
    },
    actions: {},
    modules: {},
})

export default store
